import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://unimar.mk';
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`;

function SEO({ title, description, image, url, type = 'website', structuredData }) {
  const fullTitle = title ? `${title} | Unimar Boats` : 'Unimar — Premium Fiberglass Boats | North Macedonia';
  const fullImage = image ? `${BASE_URL}${image}` : DEFAULT_IMAGE;
  const fullUrl = url ? `${BASE_URL}${url}` : BASE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {structuredData && (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
    </Helmet>
  );
}

export default SEO;
